import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type UserRole = 'user' | 'admin';
export type UserPlan = 'free' | 'pro' | 'business' | 'admin';
export type UserStatus = 'active' | 'suspended' | 'inactive';

export interface Profile {
  id: string;
  email: string;
  full_name?: string;
  avatar_url?: string;
  role?: 'user' | 'admin';
  is_admin?: boolean;
  plan: 'free' | 'starter' | 'pro' | 'business' | 'admin';
  credits: number;
  trial_active: boolean;
  trial_end_date?: string;
  created_at: string;
  updated_at: string;
}

export const CREDIT_COSTS = {
  TEMPLATE_DOWNLOAD: 25,
  PDF_EXPORT: 25,
  DOCX_EXPORT: 50,
  PREMIUM_TEMPLATE: 50,
  BUNDLE_DOWNLOAD: 75,
  SAVE_DRAFT: 25,
} as const;

export const CREDIT_PACKS = [
  { id: 'pack_500', credits: 500, price: 4.99, label: '500 Credits', popular: false, bestValue: false },
  { id: 'pack_1000', credits: 1000, price: 8.99, label: '1,000 Credits', popular: true, bestValue: false },
  { id: 'pack_2500', credits: 2500, price: 19.99, label: '2,500 Credits', popular: false, bestValue: true },
  { id: 'pack_5000', credits: 5000, price: 34.99, label: '5,000 Credits', popular: false, bestValue: false },
] as const;
